import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  selector: 'email-sso-enabled-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './sso-enabled.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    MailgunMarkAsHtmlPipe,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class SsoEnabledTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<SsoEnabledTemplateData>;
}

export type SsoEnabledTemplateData = {
  title: string;
  p1: string;
  avatar_url: string;
  p2: string;
  url: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const SsoEnabledTemplateMocks: SsoEnabledTemplateData[] = [
  {
    title: 'SSO Enabled 🔑',
    p1: 'Recruitee admin has enabled single sign-on (SSO) for ACME.',
    avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
    p2: 'Password login is no longer possible. Use the URL below to sign in with SSO.',
    url: 'https://auth.recruitee.com/sso/sign-in/acme-corp',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
  },
];
